export default {
  'component.globalHeader.search': 'Tìm kiếm',
  'component.globalHeader.search.example1': 'Ví dụ tìm kiếm 1',
  'component.globalHeader.search.example2': 'Ví dụ tìm kiếm 2',
  'component.globalHeader.search.example3': 'Ví dụ tìm kiếm 3',
  'component.globalHeader.help': 'Trợ giúp',
  'component.globalHeader.notification': 'Thông báo',
  'component.globalHeader.notification.empty': 'Bạn đã xem tất cả thông báo.',
  'component.globalHeader.message': 'Tin nhắn',
  'component.globalHeader.message.empty': 'Bạn đã xem tất cả tin nhắn.',
  'component.globalHeader.event': 'Sự kiện',
  'component.globalHeader.event.empty': 'Bạn đã xem tất cả sự kiện.',
  'component.noticeIcon.clear': 'Xóa',
  'component.noticeIcon.cleared': 'Đã xóa',
  'component.noticeIcon.empty': 'Không có thông báo',
  'component.noticeIcon.view-more': 'Xem thêm',
};
